(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = this.classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
            this.header.classList.remove('shopify-section-header-hidden');
          } else if (scrollTop > this.currentScrollTop) {
            if (!this.preventHide) requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop) {
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          }
        } else {
          this.header.classList.remove('scrolled-past-header');
          if (this.headerIsAlwaysSticky) {
            this.header.classList.remove('shopify-section-header-hidden', 'animate');
          } else {
            requestAnimationFrame(this.reset.bind(this));
          }
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-demo-stage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let observer;

    const isNearViewport = (video) => {
      const rect = video.getBoundingClientRect();
      return rect.bottom > -240 && rect.top < window.innerHeight + 240;
    };

    const playWhenAllowed = (video) => {
      if (reduceMotion.matches || video.dataset.autoplay !== 'true' || !isNearViewport(video)) return;
      video.play().catch(() => {});
    };

    const loadVideo = (video) => {
      const source = video.querySelector('source[data-src]');
      if (!source) {
        playWhenAllowed(video);
        return;
      }
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
      video.load();
      video.addEventListener('canplay', () => playWhenAllowed(video), { once: true });
    };

    const initialize = () => {
      document.querySelectorAll('.rk-demo__sound:not([data-rk-sound-ready])').forEach((button) => {
        button.dataset.rkSoundReady = 'true';
        button.addEventListener('click', () => {
          const video = button.closest('.rk-demo__frame')?.querySelector('.rk-demo__video');
          if (!video) return;
          loadVideo(video);
          const turnSoundOn = video.muted;
          video.muted = !turnSoundOn;
          button.setAttribute('aria-pressed', String(turnSoundOn));
          button.setAttribute('aria-label', turnSoundOn ? 'Mute demo sound' : 'Turn demo sound on');
          button.textContent = turnSoundOn ? button.dataset.labelOn : button.dataset.labelOff;
          if (turnSoundOn) video.play().catch(() => {});
        });
      });

      const videos = document.querySelectorAll('.rk-demo__video:not([data-rk-video-ready])');
      if (!videos.length) return;
      if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
        if (!observer) {
          observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                loadVideo(entry.target);
                playWhenAllowed(entry.target);
              } else if (entry.target.dataset.autoplay === 'true') {
                entry.target.pause();
              }
            });
          }, { rootMargin: '240px 0px', threshold: 0.05 });
        }
        videos.forEach((video) => {
          video.dataset.rkVideoReady = 'true';
          observer.observe(video);
        });
      } else {
        videos.forEach((video) => {
          video.dataset.rkVideoReady = 'true';
          loadVideo(video);
        });
      }

    };

    const applyMotionPreference = () => {
      document.querySelectorAll('.rk-demo__video').forEach((video) => {
        if (reduceMotion.matches) video.pause();
        else playWhenAllowed(video);
      });
    };

    initialize();
    reduceMotion.addEventListener?.('change', applyMotionPreference);
    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root = document) => {
      root.querySelectorAll('[data-rk-faq][data-single-open="true"]:not([data-rk-faq-ready])').forEach((section) => {
        section.dataset.rkFaqReady = 'true';
        section.querySelectorAll('details').forEach((item) => {
          item.addEventListener('toggle', () => {
            if (!item.open) return;
            section.querySelectorAll('details[open]').forEach((other) => {
              if (other !== item) other.removeAttribute('open');
            });
          });
        });
      });
    };
    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-signal-journey"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('rk-signal-journey')) return;

    class RkSignalJourney extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileLayout = window.matchMedia('(max-width: 989px)');
        this.pointerFine = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.stage = this.querySelector('.rk-signal-journey__stage');
        this.tiltSurface = this.querySelector('.rk-signal-journey__stage-wrap');
        this.carousel = this.querySelector('[data-rk-phase-carousel]');
        this.rail = this.querySelector('[data-rk-step-rail]');
        this.items = Array.from(this.querySelectorAll('[data-phase-item]'));
        this.triggers = Array.from(this.querySelectorAll('[data-phase-trigger]'));
        this.dotTriggers = Array.from(this.querySelectorAll('.rk-signal-journey__carousel-dot'));
        this.paths = Array.from(this.querySelectorAll('[data-rk-path]'));
        this.nodes = Array.from(this.querySelectorAll('.rk-signal-journey__node'));
        this.readouts = Array.from(this.querySelectorAll('[data-rk-readout]'));
        this.rpmInput = this.querySelector('[data-rk-rpm]');
        this.rpmOutputs = Array.from(this.querySelectorAll('[data-rk-rpm-output], [data-rk-rpm-display]'));
        this.motionToggle = this.querySelector('[data-rk-motion-toggle]');
        this.previousButton = this.querySelector('[data-rk-phase-previous]');
        this.nextButton = this.querySelector('[data-rk-phase-next]');
        this.countOutput = this.querySelector('[data-rk-phase-count]');
        this.statusOutput = this.querySelector('[data-rk-phase-status]');
        this.activeIndex = -1;
        this.inView = false;
        this.userPaused = false;
        this.railFrame = 0;
        this.designMode = this.dataset.designMode === 'true';
        this.onPreferenceChange = () => this.updateMotion();
        this.onLayoutChange = () => {
          this.setupChapterObserver();
          this.updateSlideAccessibility();
          if (this.mobileLayout.matches) {
            window.requestAnimationFrame(() => this.scrollToPhase(this.activeIndex, 'auto'));
          }
          this.updateMotion();
        };
        this.onVisibilityChange = () => this.updateMotion();
        this.onRailScroll = () => this.scheduleRailUpdate();
        this.onPointerMove = (event) => this.updateTilt(event);
        this.onPointerLeave = () => this.resetTilt();

        this.triggers.forEach((trigger) => {
          trigger.addEventListener('click', () => {
            const index = Number(trigger.dataset.index);
            this.setActive(index);
            if (this.mobileLayout.matches) this.scrollToPhase(index);
          }, { signal: this.controller.signal });
        });

        this.previousButton?.addEventListener('click', () => this.movePhase(-1), { signal: this.controller.signal });
        this.nextButton?.addEventListener('click', () => this.movePhase(1), { signal: this.controller.signal });
        this.querySelector('.rk-signal-journey__carousel-dots')?.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let nextIndex = this.activeIndex;
          if (event.key === 'ArrowLeft') nextIndex -= 1;
          if (event.key === 'ArrowRight') nextIndex += 1;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.items.length - 1;
          nextIndex = Math.min(Math.max(nextIndex, 0), this.items.length - 1);
          this.setActive(nextIndex);
          if (this.mobileLayout.matches) this.scrollToPhase(nextIndex);
          this.dotTriggers[nextIndex]?.focus();
        }, { signal: this.controller.signal });
        this.rpmInput?.addEventListener('input', () => this.updateRpm(), { signal: this.controller.signal });
        this.motionToggle?.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.motionToggle.setAttribute('aria-pressed', String(this.userPaused));
          this.updateMotion();
        }, { signal: this.controller.signal });
        this.rail?.addEventListener('scroll', this.onRailScroll, { signal: this.controller.signal, passive: true });
        this.tiltSurface?.addEventListener('pointermove', this.onPointerMove, { signal: this.controller.signal, passive: true });
        this.tiltSurface?.addEventListener('pointerleave', this.onPointerLeave, { signal: this.controller.signal });
        this.addEventListener('shopify:block:select', (event) => {
          const item = event.target.closest?.('[data-phase-item]');
          if (!item) return;
          const index = Number(item.dataset.index);
          this.setActive(index, false);
          if (this.mobileLayout.matches) this.scrollToPhase(index, 'auto');
        }, { signal: this.controller.signal });
        document.addEventListener('visibilitychange', this.onVisibilityChange, { signal: this.controller.signal });
        this.reducedMotion.addEventListener?.('change', this.onPreferenceChange);
        this.mobileLayout.addEventListener?.('change', this.onLayoutChange);

        this.viewportObserver = new IntersectionObserver((entries) => {
          this.inView = Boolean(entries[0]?.isIntersecting);
          this.updateMotion();
        }, { rootMargin: '180px 0px', threshold: 0.01 });
        this.viewportObserver.observe(this);
        this.setActive(Math.max(0, Number(this.dataset.activeStep) || 0), false);
        this.updateRpm();
        this.setupChapterObserver();
        this.updateMotion();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = undefined;
        this.viewportObserver?.disconnect();
        this.chapterObserver?.disconnect();
        this.reducedMotion?.removeEventListener?.('change', this.onPreferenceChange);
        this.mobileLayout?.removeEventListener?.('change', this.onLayoutChange);
        window.cancelAnimationFrame(this.railFrame);
      }

      setupChapterObserver() {
        this.chapterObserver?.disconnect();
        if (this.mobileLayout.matches || this.designMode || this.dataset.sticky !== 'true') return;
        this.chapterObserver = new IntersectionObserver((entries) => {
          const active = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
          if (active) this.setActive(Number(active.target.dataset.index), false);
        }, { rootMargin: '-38% 0px -38% 0px', threshold: [0, 0.05, 0.35, 0.7] });
        this.items.forEach((item) => this.chapterObserver.observe(item));
      }

      setActive(index, announce = true) {
        if (!this.items.length) return;
        const nextIndex = Math.min(Math.max(index, 0), this.items.length - 1);
        const previousIndex = this.activeIndex;
        const changed = previousIndex !== nextIndex;
        if (changed) {
          this.dataset.carouselDirection = previousIndex > nextIndex ? 'previous' : 'next';
        }
        this.activeIndex = nextIndex;
        this.dataset.activeStep = String(nextIndex);
        this.items.forEach((item, itemIndex) => {
          item.classList.toggle('is-active', itemIndex === nextIndex);
          item.classList.toggle('is-before', itemIndex < nextIndex);
          item.classList.toggle('is-after', itemIndex > nextIndex);
        });
        this.triggers.forEach((trigger) => {
          const isActive = Number(trigger.dataset.index) === nextIndex;
          trigger.classList.toggle('is-active', isActive);
          if (isActive) {
            trigger.setAttribute('aria-current', 'step');
          } else {
            trigger.removeAttribute('aria-current');
          }
        });
        this.paths.forEach((path, pathIndex) => {
          path.classList.toggle('is-active', pathIndex === nextIndex);
          path.classList.toggle('is-complete', pathIndex < nextIndex);
        });
        this.nodes.forEach((node, nodeIndex) => {
          node.classList.toggle('is-active', nodeIndex === nextIndex);
          node.classList.toggle('is-complete', nodeIndex < nextIndex);
        });
        this.readouts.forEach((readout, readoutIndex) => {
          const isActive = readoutIndex === nextIndex;
          readout.classList.toggle('is-active', isActive);
          readout.setAttribute('aria-hidden', String(!isActive));
        });
        if (this.previousButton) this.previousButton.disabled = nextIndex === 0;
        if (this.nextButton) this.nextButton.disabled = nextIndex === this.items.length - 1;
        if (this.countOutput) {
          this.countOutput.textContent = `${String(nextIndex + 1).padStart(2, '0')} / ${String(this.items.length).padStart(2, '0')}`;
        }
        this.updateSlideAccessibility();
        if (announce && changed && previousIndex >= 0 && this.statusOutput) {
          const title = this.items[nextIndex].querySelector('.rk-signal-journey__step-title')?.textContent?.trim() || '';
          this.statusOutput.textContent = `Phase ${nextIndex + 1} of ${this.items.length}: ${title}`;
        }
      }

      updateSlideAccessibility() {
        const desktop = !this.mobileLayout.matches;
        this.items.forEach((item, itemIndex) => {
          if (desktop && itemIndex !== this.activeIndex) {
            item.setAttribute('aria-hidden', 'true');
          } else {
            item.removeAttribute('aria-hidden');
          }
        });
      }

      scrollToPhase(index, behavior) {
        const item = this.items[index];
        if (!item) return;
        item.scrollIntoView({
          behavior: behavior || (this.reducedMotion.matches ? 'auto' : 'smooth'),
          block: 'nearest',
          inline: 'center'
        });
      }

      movePhase(direction) {
        if (!this.items.length) return;
        const nextIndex = Math.min(Math.max(this.activeIndex + direction, 0), this.items.length - 1);
        if (nextIndex === this.activeIndex) return;
        this.setActive(nextIndex);
        if (this.mobileLayout.matches) this.scrollToPhase(nextIndex);
      }

      scheduleRailUpdate() {
        if (!this.mobileLayout.matches || this.railFrame) return;
        this.railFrame = window.requestAnimationFrame(() => {
          this.railFrame = 0;
          if (!this.rail || !this.items.length) return;
          const railCenter = this.rail.getBoundingClientRect().left + this.rail.clientWidth / 2;
          const closest = this.items.reduce((best, item, index) => {
            const rect = item.getBoundingClientRect();
            const distance = Math.abs(rect.left + rect.width / 2 - railCenter);
            return distance < best.distance ? { index, distance } : best;
          }, { index: 0, distance: Number.POSITIVE_INFINITY });
          if (closest.index !== this.activeIndex) this.setActive(closest.index);
        });
      }

      updateRpm() {
        const rpm = Number(this.rpmInput?.value || 3200);
        const ratio = Math.min(Math.max((rpm - 800) / 6200, 0), 1);
        const needle = -120 + ratio * 240;
        const speedFactor = Math.max(Number(this.dataset.animationSpeed) || 100, 1) / 100;
        const duration = Math.max((2.2 - ratio * 1.35) / speedFactor, 0.42);
        this.style.setProperty('--rk-rpm-level', String(ratio));
        this.style.setProperty('--rk-needle-angle', needle + 'deg');
        this.style.setProperty('--rk-signal-duration', duration + 's');
        this.style.setProperty('--rk-wave-scale', String(0.48 + ratio * 0.52));
        const formatted = new Intl.NumberFormat(document.documentElement.lang || undefined).format(rpm);
        this.rpmOutputs.forEach((output) => { output.textContent = formatted; });
      }

      updateMotion() {
        const shouldRun = this.inView && !this.userPaused && !this.reducedMotion.matches && !document.hidden;
        this.dataset.motion = shouldRun ? 'running' : 'paused';
        if (!this.motionToggle) return;
        const label = this.userPaused ? this.motionToggle.dataset.labelPlay : this.motionToggle.dataset.labelPause;
        this.motionToggle.setAttribute('aria-label', label || '');
      }

      updateTilt(event) {
        if (this.dataset.pointerTilt !== 'true' || !this.pointerFine.matches || this.reducedMotion.matches || !this.tiltSurface) return;
        const rect = this.tiltSurface.getBoundingClientRect();
        const x = Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 1);
        const y = Math.min(Math.max((event.clientY - rect.top) / rect.height, 0), 1);
        this.style.setProperty('--rk-tilt-y', ((x - 0.5) * 7).toFixed(2) + 'deg');
        this.style.setProperty('--rk-tilt-x', ((0.5 - y) * 5).toFixed(2) + 'deg');
        this.style.setProperty('--rk-pointer-x', (x * 100).toFixed(1) + '%');
        this.style.setProperty('--rk-pointer-y', (y * 100).toFixed(1) + '%');
      }

      resetTilt() {
        this.style.setProperty('--rk-tilt-y', '0deg');
        this.style.setProperty('--rk-tilt-x', '0deg');
        this.style.setProperty('--rk-pointer-x', '50%');
        this.style.setProperty('--rk-pointer-y', '35%');
      }
    }

    customElements.define('rk-signal-journey', RkSignalJourney);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-theme-shell"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.documentElement;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let observer;
    let ticking = false;

    const updateProgress = () => {
      const bar = document.querySelector('.rk-scroll-progress span');
      if (!bar) return;
      const distance = document.documentElement.scrollHeight - window.innerHeight;
      const progress = distance > 0 ? Math.min(window.scrollY / distance, 1) : 0;
      bar.style.transform = `scaleX(${progress})`;
      ticking = false;
    };

    const reveal = () => {
      if (observer) observer.disconnect();
      const elements = document.querySelectorAll('[data-rk-reveal]:not(.rk-is-visible)');
      if (reduceMotion.matches) {
        elements.forEach((element) => element.classList.add('rk-is-visible'));
        return;
      }
      if (!('IntersectionObserver' in window)) {
        elements.forEach((element) => element.classList.add('rk-is-visible'));
        return;
      }
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('rk-is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      elements.forEach((element) => observer.observe(element));
    };

    const initialize = () => {
      root.classList.add('rk-motion-ready');
      reveal();
      updateProgress();
    };

    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateProgress);
    }, { passive: true });
    document.addEventListener('shopify:section:load', initialize);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      console.log('Video player element not found, creating it');
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          console.log('Video started playing');
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();
})();
